module.exports = "<app-object-viewer title=\"Access Token\" [value]=\"tokenResponse\"></app-object-viewer>"